import React from 'react';
import type ServicedeskKnowledgeHubLandingType from '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-landing/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubLanding = lazyForPaint<
	typeof ServicedeskKnowledgeHubLandingType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-landing", jiraSpaEntry: "async-servicedesk-knowledge-hub-landing" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-landing'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubLanding}
		pageId="spa-apps/servicedesk/knowledge-hub/landing-page"
		shouldShowSpinner
	/>
);
